/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Precheck_AbortInputs */

const en_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abort`)
};

const fr_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonner`)
};

const de_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const it_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aborto`)
};

const ru_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

const zh_cn2_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中止`)
};

const ja_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アボート`)
};

const hi_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीच में बंद करें`)
};

const pt_pt2_audio_description_export_precheck_abort = /** @type {(inputs: Audio_Description_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

/**
* | output |
* | --- |
* | "Abort" |
*
* @param {Audio_Description_Export_Precheck_AbortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_precheck_abort = /** @type {((inputs?: Audio_Description_Export_Precheck_AbortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Precheck_AbortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_precheck_abort(inputs)
	if (locale === "de") return de_audio_description_export_precheck_abort(inputs)
	if (locale === "it") return it_audio_description_export_precheck_abort(inputs)
	if (locale === "ru") return ru_audio_description_export_precheck_abort(inputs)
	if (locale === "es") return es_audio_description_export_precheck_abort(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_precheck_abort(inputs)
	if (locale === "ja") return ja_audio_description_export_precheck_abort(inputs)
	if (locale === "hi") return hi_audio_description_export_precheck_abort(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_precheck_abort(inputs)
	return en_audio_description_export_precheck_abort(inputs)
});